"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.titleHrefNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
/**
 * normalizador del modulo MODULO_TITLEHREF
 * @param {object} fields
 * @returns
 */
const titleHrefNormalizer = (data) => {
    try {
        let res = {};
        if (Array.isArray(data)) {
            const normalizedInfo = {};
            const hrefArray = [];
            data.forEach((element, i) => {
                const { description, href, title, titleHref, listadoHref } = element === null || element === void 0 ? void 0 : element.fields;
                const card = {};
                if (!!title) {
                    card["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-1"]), { text: title });
                }
                if (listadoHref) {
                    listadoCards.map((item) => {
                        // const { fields } = item;
                        const { titleHref, href } = item;
                        let titleItem = "";
                        let hrefItem = "";
                        if (!!titleHref) {
                            titleItem = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-2"]), { text: titleHref });
                        }
                        if (!!href) {
                            hrefItem = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["CustomLink-1"]), { href: href, title: title || '' });
                        }
                        hrefArray.push({ titleHref: titleHref, href: hrefItem });
                    });
                    card["ListHref"] = hrefArray;
                }
                else {
                    if (!!titleHref) {
                        card["Text-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-2"]), { text: titleHref });
                    }
                    if (!!href) {
                        card["CustomLink-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["CustomLink-1"]), { href: href, title: title || '' });
                    }
                }
                const hasItems = Object.keys(card).length > 0;
                if (hasItems) {
                    normalizedInfo[`Charac-${i}`] = card;
                }
                res = normalizedInfo;
            });
            return res;
        }
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.titleHrefNormalizer = titleHrefNormalizer;
exports.default = exports.titleHrefNormalizer;
//# sourceMappingURL=index.js.map